import React from 'react';
import ActiveWorkout from "fit/components/ActiveWorkout";

const ActiveWorkoutRoute =()=>{
    return <ActiveWorkout/>
};

export default ActiveWorkoutRoute;